module.exports = __webpack_public_path__ + "static/visual_4_2_eg-b9865d26ae2a02214ef20ee898ee52f0.png";